import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CapacityWarningDialogData {
  title?: string;
  message: string;
  leftButtonText?: string;
  rightButtonText?: string;
  iconPath?: string;
}

@Component({
    selector: 'hmt-capacity-warning-dialog',
    templateUrl: './capacity-warning-dialog.component.html',
    styleUrls: ['./capacity-warning-dialog.component.scss'],
    standalone: false
})
export class CapacityWarningDialogComponent implements OnInit {
  // Default values
  title: string;
  message: string;
  leftButtonText: string;
  rightButtonText: string;
  iconPath: string;

  constructor(
    public dialogRef: MatDialogRef<CapacityWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CapacityWarningDialogData
  ) {
    this.title = data.title || '';
    this.message = data.message;
    this.leftButtonText = data.leftButtonText || 'Apply to Non Modified Vehicles Only';
    this.rightButtonText = data.rightButtonText || 'Apply to all vehicles';
    this.iconPath = data.iconPath || 'assets/icons/warning_popup.svg';
  }

  ngOnInit(): void {
  }

  onLeftButtonClick(): void {
    this.dialogRef.close('nonModified');
  }

  onRightButtonClick(): void {
    this.dialogRef.close('all');
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}
